<template>
  <div>
    <Header class="yh-header" active="/ovop" showSub :productValue="'5'">
      <template v-slot:left>
        <ImageAndName
          :image="util.getImageUrl(util.getHead(util.string2Array(get.images)), '48x48')"
          :name="get.name"
          :code="get.code"
        />
      </template>
      <template v-slot:right>
        <Feedback target-name="一村一品" :target-id="$route.params.id" />
        <Favourite target-name="ovop" :target-id="$route.params.id"  :purchaseLevel="21"/>
      </template>
    </Header>
    <div style="height: 130px"></div>
    <el-container class="container">
      <el-main>
        <OneVillageOneProductBase :get="get" :category="category" />
      </el-main>
    </el-container>
    <div style="min-height: 70px"></div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import ProductAside from "@/components/ProductAside.vue";
import OneVillageOneProductBase from "@/components/OneVillageOneProductBase.vue";
import ProductHeader from "@/components/ProductHeader.vue";
import ProductImages from "@/components/ProductImages.vue";

import Favourite from "@/components/Favourite.vue";
import ImageAndName from "@/components/ImageAndName.vue";
import Feedback from "@/components/Feedback";

export default {
  name: "OneVillageOneProductDetail",
  components: {
    Header,
    ProductAside,
    OneVillageOneProductBase,
    ProductHeader,
    ProductImages,

    Favourite,
    ImageAndName,
    Feedback
  },
  data() {
    return {
      category: ""
    };
  },
  computed: {
    get() {
      return this.$store.state.ovop.oneVillageOneProduct.get;
    },
    collect() {
      return this.$store.state.user.userFavorite.retrieve.results.length > 0
        ? 1
        : 0;
    }
  },
  async created() {
    await this.$store.dispatch("oneVillageOneProduct", {
      packageName: "ovop",
      className: "oneVillageOneProduct",
      methodName: "get",
      params: {
        id: this.$route.params.id
      }
    });

    const response = await this.ajax.doPost({
      packageName: "product",
      className: "productCategory",
      methodName: "getCategoryByCode",
      params: {
        code: this.get.categoryCode
      }
    });

    this.category = response.map(e => e.name).join("·");

    this.$store.dispatch("createHistory", {
      packageName: "user",
      className: "userHistory",
      methodName: "create",
      params: {
        targetName: "ovop",
        targetId: this.$route.params.id
      }
    });

    this.ajax.doPost({
      packageName: "user",
      className: "userAnalysis",
      methodName: "create",
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: "一村一品-详情",
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    });
  }
};
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 5px auto;
}
.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  // box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.el-main {
  position: relative;
  padding-top: 0;
}
.fav {
  // position: absolute;
  // right: 20px;
  // top: 20px;
}
</style>
